import {request} from "./request";
import store from '../store/index'

// 获取视频类别列表
export function getVideoClassList(pagesize, page) {
    return request({
        url: '/hkt_admin/videopublicclass/get_video_public_class_list',
        headers: {
            'token': store.state.token
        },
        params: {
            pagesize,
            page
        }
    })
}
// 添加视频类别
export function addVideoClass(name, is_show) {
    return request({
        url: '/hkt_admin/videopublicclass/add_video_public_class',
        headers: {
            'token': store.state.token
        },
        params: {
            name,
            is_show
        }
    })
}
// 删除视频类别
export function delVideoClass(class_id) {
    return request({
        url: '/hkt_admin/videopublicclass/del_video_public_class',
        headers: {
            'token': store.state.token
        },
        params: {
            class_id
        }
    })
}
// 修改视频类别
export function editVideoClass(class_id, name, is_show) {
    return request({
        url: '/hkt_admin/videopublicclass/edit_video_public_class',
        headers: {
            'token': store.state.token
        },
        params: {
            class_id,
            name,
            is_show
        }
    })
}

// 获取视频列表
export function getVideoList(pagesize, page, title, class_id, admin_id, srarch_time, release_state) {
    return request({
        url: '/hkt_admin/videopublic/get_video_public_list',
        headers: {
            'token': store.state.token
        },
        params: {
            pagesize,
            page,
            title,
            class_id,
            admin_id,
            srarch_time,
            release_state
        }
    })
}
// 添加视频
export function addVideo(data) {
    return request({
        url: '/hkt_admin/videopublic/add_video_public',
        headers: {
            'token': store.state.token
        },
        method: 'post',
        data: data
    })
}
// 编辑视频
export function editVideo(data) {
    return request({
        url: '/hkt_admin/videopublic/edit_video_public',
        headers: {
            'token': store.state.token
        },
        method: 'post',
        data: data
    })
}
// 发布视频
export function videoRelease(video_id, release_state) {
    return request({
        url: '/hkt_admin/videopublic/video_public_release',
        headers: {
            'token': store.state.token
        },
        method: 'post',
        params: {
            video_id,
            release_state,
        }
    })
}
